import Vue from 'vue'
import Vuex from 'vuex'
import '@/assets/js/api'

Vue.use(Vuex)


//* State
export const state = () => ({

  locationRenew: {
    area:"萬巒",
    path:'/',
    number: 0,
    name: "萬巒",
    inf: "萬巒豬腳遠近馳名，知名的豬腳店家聚集成了豬腳一條街，用餐時刻總是吸引許多觀光客；萬巒的可可也是特產，屏東可可園區除了販售巧克力商品，還有食農體驗、市集與AR體驗等等活動，更舉辦屏東可可臺灣巧克力節推廣臺灣在地巧克力。萬巒還有許多自行車道，歡迎遊客用單車走訪萬巒，認識萬巒！",
    mainimg:"location1/p1-1-1.jpg",
    imgList: {
      items: [
        {
          id:11101,
          img: "location1/p1-1-1.jpg"
        },
      ]
    },
    iframemap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117880.48495717981!2d120.50715688147906!3d22.587885186305787!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e23bb34e5f5fd%3A0xf5302d20651c1c0f!2zOTIz5bGP5p2x57ij6JCs5beS6YSJ!5e0!3m2!1szh-TW!2stw!4v1698312250005!5m2!1szh-TW!2stw",
  },
});



export const mutations = {
  // 
  SET_location(state, payload) {
    state.locationRenew = payload;
  },


};


export default new Vuex.Store({
  state,
  mutations,
})
